// extracted by mini-css-extract-plugin
export default {"wm-light":"C5Dke_wm-light","sweep":"MV4i6_sweep"};